import { C_ACTION } from '../constans';

export const helpers = (state = [], action) => {
  switch (action.type) {
    case C_ACTION.ADD_HELPERDATA: {
      return [...state, ...action.data];
    }
    case C_ACTION.DELETE_HELPER: {
      return [];
    }

    default:
      return state;
  }
};
